export default __webpack_public_path__ + "static/media/Kashish.4ea478e5.jpg";